import { useRouter, useRuntimeConfig } from '#imports'

import { authLegacyAPI, oauthAPI } from '@backmarket/http-api'
import { $httpFetch } from '@backmarket/nuxt-module-http/$httpFetch'

import { scopedStorage, sharedStorage } from '../storage'

import { useAuthOrigin } from './useAuthOrigin'
import { CACHE_KEY as STATE_CACHE_KEY } from './useAuthState'
import { CACHE_KEY as ENDPOINTS_CACHE_KEY } from './useEndpoints'
import { CACHE_KEY as PKCE_CACHE_KEY } from './usePkce'

export function useLogout() {
  /**
   * Log the current user out.
   *
   * This functions takes care of logging people out from everywhere (Badoom,
   * the Identity stack, etc), and clears the different internal storages. In
   * the end, people get redirect to the default location given as part of
   * the module configuration.
   *
   * @example
   * const { logout } = useLogout()
   *
   * logout() // Call this whenever you want.
   */
  async function logout() {
    const router = useRouter()
    const config = useRuntimeConfig().public.oauth

    await $httpFetch(authLegacyAPI.postClientLogout)
    await $httpFetch(oauthAPI.getLogout, { baseURL: useAuthOrigin() })

    sharedStorage.removeItem(STATE_CACHE_KEY)
    sharedStorage.removeItem(PKCE_CACHE_KEY)
    scopedStorage.removeItem(ENDPOINTS_CACHE_KEY)

    // TODO: Compatibility layer with the implementation that lives on
    // TODO: Pastrami. This won't be required anymore after the whole
    // TODO: authentication flow takes place on Front Office.
    localStorage.removeItem('oauth2.oauthState')
    localStorage.removeItem('oauth2.pkceVerifier')
    sessionStorage.removeItem('oauth2.next_page')
    sessionStorage.removeItem('oauth2.endpoints')

    // Force a reload to clear the in-memory data (stores, components, etc).
    const redirect = router.resolve(config.defaultRedirectLocation)
    window.location.assign(redirect.href)
  }

  return { logout }
}
